export default __webpack_public_path__ + "static/media/chatIcon2.28b534ca.svg";